<template>
    <div>
        <b-modal id="modal-prevent-closing" centered class="header-modal" no-close-on-backdrop hide-footer ref="modal-warning-change-public-to-private">
            <div class="modal-warning-change-public-to-private__body container wrap-form-create-update-chapter">
                <h4>
                    <strong>
                        Cảnh báo
                    </strong>
                </h4>
                <p class="font-size-17 primary-color-txt font-sanpro-light">
                    Cần chuyển bài giảng điện tử sang chế độ công khai để giao bài.
                </p>
                <div class="modal__actions text-right">
                    <a href="javascript:;" class="btn btn-primary font-size-17 font-sanpro-semibold btn-delete px-4" @click="handleHideModal">Đóng</a>
                </div>
            </div>
        </b-modal>
    </div>
</template>
<script>

export default {
    name: "ModalWarningAssignPost",
    data() {
        return {
            
        }
    },
    mounted(){
        this.$refs['modal-warning-change-public-to-private'].show()
    },
    methods: {
        handleHideModal() {
            this.$emit('closeModal')
        }
    }
}
</script>
<style lang="scss" scoped>
.modal-warning-change-public-to-private__body {
    padding: 20px;
    background-color: white;
    .modal__actions{
        
        .btn-delete{
            color: white;
            height: auto;
            border-radius: 8px;
            font-family: sans-serif;
        }
        .btn-cancel{
            color: #212529;
            margin-right: 10px;
            font-family: sans-serif;
        }
    }
}

.form_action {
    margin-top: 10px;
    padding-bottom: 10px;
}

.justity-content-space-between {
    justify-content: center
}
</style>